import React, { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

import { bemJoin } from 'bem-join'

import { useIntl } from '@app/intl/Intl'
import { Text } from '@app/lib/typography/Text/Text'

export const InvoicingTotalCostSection = () => {
  const b = bemJoin('court-case-invoicing-form')
  const { formatMessage } = useIntl()

  const { watch, setValue } = useFormContext()

  const [proceduralFee, appointmentFee, settlementFee, expenses, otherCosts, vat] = watch([
    'ProceduralFee',
    'AppointmentFee',
    'SettlementFee',
    'Expenses',
    'OtherCosts',
    'Vat'
  ])

  const netTotal =
    Math.round(
      (proceduralFee + settlementFee + appointmentFee + Number(expenses) + Number(otherCosts)) * 100
    ) / 100

  const vatTotal = Math.round(netTotal * vat * 100) / 100
  const grossTotal = Math.round((netTotal + vatTotal) * 100) / 100

  useEffect(() => {
    setValue('NetTotal', netTotal)
    setValue('VatTotal', vatTotal)
    setValue('GrossTotal', grossTotal)
  }, [vatTotal])

  return (
    <div className={b('section')}>
      <Text size={'ml'} weight={'bold'}>
        {formatMessage({ id: 'CourtCases.Invoicing.Section.Total.Title' })}
      </Text>
      <div className={b('total-cost')}>
        <div>
          {formatMessage({ id: 'CourtCases.Invoicing.Section.Total.Net' })}
          <Text size={'xl'} weight={'bold'} color={'primary'}>
            {netTotal.toFixed(2)} €
          </Text>
        </div>
        <div>
          {formatMessage({ id: 'CourtCases.Invoicing.Section.Total.Gross' })}
          <Text size={'xl'} weight={'bold'} color={'primary'}>
            {grossTotal.toFixed(2)} €
          </Text>
        </div>
      </div>
    </div>
  )
}
